<app-vendordash-overdue
	[loadAgedInternally]="false"
	[agedData]="agedResults"
	(viewData)="viewData.emit($event)"
	(refreshRequested)="refreshAged()"
>
	<!-- Filter chip row projected into the card header top-right toolbar slot -->
	<div vendordash-asof-toolbar class="overdue-filter-chips">
		<!-- Labelled so the date controls read as an "as of" aging, not just view toggles —
		     accounting was looking for an "AP as of" option and didn't recognise bare chips. -->
		<span class="asof-caption" *ngIf="allow_as_of">As of</span>
		<button
			class="filter-chip"
			[class.active]="overdueDateMode === 'today'"
			(click)="selectMode('today')"
			type="button"
		>Today</button>

		<button *ngIf="allow_as_of"
			class="filter-chip"
			[class.active]="overdueDateMode === '30d'"
			(click)="selectMode('30d')"
			type="button"
		>30d</button>

		<!-- Custom chip opens the date-picker flyout -->
		<button *ngIf="allow_as_of"
			class="filter-chip"
			[class.active]="overdueDateMode === 'custom'"
			[matMenuTriggerFor]="customDateMenu"
			#customMenuTrigger="matMenuTrigger"
			type="button"
		>
			<span *ngIf="overdueDateMode !== 'custom' || !customDateLabel">Custom</span>
			<span *ngIf="overdueDateMode === 'custom' && customDateLabel">{{ customDateLabel }}</span>
		</button>
	</div>

	<!-- Custom date flyout menu -->
	<mat-menu #customDateMenu="matMenu" class="overdue-date-menu" xPosition="before">
		<div class="overdue-date-menu-content" (click)="$event.stopPropagation()">
			<p class="overdue-date-menu-title">As of date</p>
			<mat-form-field appearance="outline" class="overdue-asof-date-field">
				<mat-label>Date</mat-label>
				<input
					matInput
					[matDatepicker]="asOfPicker"
					[(ngModel)]="customAsOfDate"
					(dateChange)="applyCustomDate()"
				/>
				<mat-datepicker-toggle matSuffix [for]="asOfPicker"></mat-datepicker-toggle>
				<mat-datepicker #asOfPicker></mat-datepicker>
			</mat-form-field>
			<div class="overdue-date-menu-actions">
				<button
					mat-stroked-button
					class="overdue-menu-btn-clear"
					(click)="clearCustomDate()"
					type="button"
				>Clear</button>
				<button
					mat-flat-button
					color="primary"
					class="overdue-menu-btn-apply"
					(click)="applyCustomDate()"
					[disabled]="!customAsOfDate"
					type="button"
				>Apply</button>
			</div>
		</div>
	</mat-menu>

	<!-- Back-side label: show active filter context after flipping the card -->
	<span vendordash-asof-label class="vendordash-asof-label">
		<ng-container [ngSwitch]="overdueDateMode">
			<ng-container *ngSwitchCase="'today'">Today</ng-container>
			<ng-container *ngSwitchCase="'30d'">Last 30d</ng-container>
			<ng-container *ngSwitchCase="'custom'">As of: {{ customDateLabel || '—' }}</ng-container>
		</ng-container>
	</span>
</app-vendordash-overdue>
